import { useEffect } from 'react'
import { DadosContainerDefault } from '../../components/Styles'
import Indicadores from '../../components/Indicadores'

function IndicadoresPage() {
  useEffect(() => {
    document.title = 'Indicadores | Gesttor'
  })
  return (
    <DadosContainerDefault>
      <Indicadores />
    </DadosContainerDefault>
  )
}

export default IndicadoresPage